import { AnyAction, Dispatch } from 'redux';
import { ApiEndpoint } from '../../../TCSMApp/global/constants/api-endpoints';
import { apiAction } from '../../../TCSMApp/global/ducks/base-api';
import { ApiAction } from '../../../TCSMApp/global/models/api-model';
import { DefaultEcdEpiApiState, EcdEpiApiState } from '../../root/ecd-model';
import { EcdEpiApiActionTypes } from '../models/epi-model';

export const standAlone = (window as any)?.bootstrap?.standAlone;
export const baseUrl = `${standAlone ? ApiEndpoint.contentApi : ''}/api/v1/epicontent`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const EcdEpiApiReducer = (state: EcdEpiApiState = DefaultEcdEpiApiState, action: AnyAction) : EcdEpiApiState => {	

	switch (action.type) {
		case EcdEpiApiActionTypes.SET_EPI_PROPS:
			return {
				...state,
				contentState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};

		case EcdEpiApiActionTypes.SET_LABEL_EPI_PROPS:
			return {
				...state,
				labelSettingState: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};	

		case EcdEpiApiActionTypes.SET_SITE_SETTINGS_PROPS:
			return {
				...state,
				siteSettingsState: {
					siteSettings: action.payload,
					siteSettingsLoaded: true,
				},
			};		

		case EcdEpiApiActionTypes.SET_EPI_PAGE_DATA:
			return {
				...state,
				pageData: {
					epiContent: action.payload,
					contentLoaded: true,
				},
			};

		case EcdEpiApiActionTypes.UNLOAD_EPI_PAGE_DATA:
			return {
				...state,
				pageData: {
					epiContent: null,
					contentLoaded: false,
				},
			};		

		case EcdEpiApiActionTypes.SET_CLERGY_SETTINGS_PROPS:
			return {
				...state,
				clergySettingsState: {
					clergySettings: action.payload,
					clergySettingsLoaded: true,
				},
			};	

		case EcdEpiApiActionTypes.SET_PARISH_SETTINGS_PROPS:
			return {
				...state,
				parishSettingsState: {
					parishSettings: action.payload,
					parishSettingsLoaded: true,
				},
			};

		case EcdEpiApiActionTypes.SET_MAIL_SETTINGS_PROPS:
			return {
				...state,
				mailSettingsState: {
					mailSettings: action.payload,
					mailSettingsLoaded: true,
				},
			};	

		default:
			return state;
	}
};

export const setEpiProps = (data: any) => {
	return {
		type: EcdEpiApiActionTypes.SET_EPI_PROPS,
		payload: data,
	};
};

export const setLabelSetting = (data: any) => {
	return {
		type: EcdEpiApiActionTypes.SET_LABEL_EPI_PROPS,
		payload: data,
	};
};

export const setSiteSettingsProps = (data: any) => {
	return {
		type: EcdEpiApiActionTypes.SET_SITE_SETTINGS_PROPS,
		payload: data,
	};
};

export const setEpiContent = (data: any) => {
	return {
		type: EcdEpiApiActionTypes.SET_EPI_PAGE_DATA,
		payload: data,
	};
};

export const unloadEpiContent = () => {
	return {
		type: EcdEpiApiActionTypes.UNLOAD_EPI_PAGE_DATA,
	};
};

export const getEcdEpiPropsOnSuccess = (siteSettings: boolean, dispatch: Dispatch<any>, setter: (data: any) => { type: EcdEpiApiActionTypes; payload: any; }): (data: any) => void => {
	return (dataSucess) => {
		if (siteSettings) {
			dispatch(setSiteSettingsProps(dataSucess));
			return;
		}

		dispatch(setter(dataSucess));
	};
};

export const getEcdEpiProps = (dispatch: Dispatch<any>, contentId: string, payloadData: any, language: string = 'en', siteSettings: boolean = false, setter = setEpiProps): ApiAction => {
	return apiAction({
		url: `${baseUrl}/getbyid/?contentId=${contentId}&language=${language}`,
		onSuccess: getEcdEpiPropsOnSuccess(siteSettings, dispatch, setter),
		payloadData,
	});
};

export const getEcdEpiContent = (url: string, language: string = 'en', payloadData: any, onSuccess: (data) => void, onFailure: () => void): ApiAction => {
	return apiAction({
		url: `${baseUrl}/getpagefromurl/?url=${url}&language=${language}`,
		onSuccess,
		onFailure,
		payloadData,
	});
};

export const setClergySettingsProps = (data: any) => {
	return {
		type: EcdEpiApiActionTypes.SET_CLERGY_SETTINGS_PROPS,
		payload: data,
	};
};

export const setParishSettingsProps = (data: any) => {
	return {
		type: EcdEpiApiActionTypes.SET_PARISH_SETTINGS_PROPS,
		payload: data,
	};
};

export const setMailSettingsProps = (data: any) => {
	return {
		type: EcdEpiApiActionTypes.SET_MAIL_SETTINGS_PROPS,
		payload: data,
	};
};